import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PeacefulHero from '../../Components/Hero/PeacefulHero';
import TicketOverviewAgencyTicketRow from '../../Components/TicketOverviewAgencyTicketRow/TicketOverviewAgencyTicketRow';
import filterTickets from '../../utils/filterTickets';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LogInModal from 'flarum/forum/components/LogInModal';
import TicketStatusFilter from '../../Components/TicketFilters/TicketStatusFilter';
import SortTicketsFilter from '../../Components/TicketFilters/SortTicketsFilter';
import TicketAssigneeFilter from '../../Components/TicketFilters/TicketAsigneeFilter';
import TicketLanguageFilter from '../../Components/TicketFilters/TicketLanguageFilter';
import Tooltip from 'flarum/common/components/Tooltip';

export default class OverviewAgent extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Redirect if support tickets are disabled
    if (app.forum.attribute('supportTicketsEnabled') == false) {
      m.route.set(app.route('knowledgeBase'));
      return;
    }

    this.waitForNextLoad = false;

    // Filter
    this.showSearch = false;

    this.filter = this.getFilter();

    this.data = {
      isLoading: false,
      hasMore: false,
      list: [],
    };

    app.setTitle(
      `${app.translator.trans('v17development-flarum-support.forum.tickets.overview.title')} - ${app.translator.trans(
        'v17development-flarum-support.forum.support_tickets'
      )}`
    );

    if (!app.session.user) {
      setTimeout(() => app.modal.show(LogInModal), 100);

      return;
    } else if (!app.forum.attribute('canViewTickets')) {
      m.route.set(app.route('ticketsOverview'));
      return;
    }

    // Open tickets
    this.loadData(true);
  }

  loadData(firstLoad) {
    if (this.data.isLoading) {
      this.waitForNextLoad = true;
      return;
    }

    this.data.isLoading = true;
    m.redraw();

    let url = ``;

    if (firstLoad) {
      const mapFilter = this.filter.status.map((filter) => `type[]=${filter}`);

      url = `support/tickets?${mapFilter.join('&')}`;
      this.data.list = [];
    } else {
      url = this.data.hasMore.replace(app.forum.attribute('apiUrl'), '');
    }

    // Filter by language
    if (this.filter.language) {
      const languageFilter = this.filter.language.map((filter) => `language[]=${filter}`);

      url += `${languageFilter.join('&')}&`;
    }

    // Filter by assignee
    if (this.filter.assignees) {
      const assigneesFilter = this.filter.assignees.map((filter) => `assignee[]=${filter}`);

      url += assigneesFilter.join('&');
    }

    url += `&sortColumn=${this.filter.sortColumn}&sortDirection=${this.filter.sortDirection}`;

    // Show solved tickets
    if (this.filter.showSolved) {
      url += `&showSolved=true`;
    }

    // Load data
    app.store
      .find(url)
      .then((data) => {
        if (this.waitForNextLoad) {
          this.data.isLoading = false;
          this.waitForNextLoad = false;
          this.loadData(true);
          return;
        }

        const list = this.data.list;

        // Add new data to the list
        data.map((ticket) => list.push(ticket));

        this.data = {
          isLoading: false,
          hasMore: data.payload.links && data.payload.links.next ? data.payload.links.next : false,
          filter: this.filter.status,
          list,
        };
      })
      .catch(() => {})
      .then(() => m.redraw());
  }

  view() {
    // Do not load anything if the user is not logged in
    if (!app.session.user) {
      return <PeacefulHero />;
    }

    const open = filterTickets(this.data.list, this.filter.status);

    return (
      <div className={'Flarum-Support-TicketOverview'}>
        <PeacefulHero hideContent />
        <div className="Support-Block Block-CategoryFullWidth Support-Ticket">
          <div className="container">
            <div className="SupportCategoryContainer">
              <div className="Category-Item-Container Category-No-Border">
                <div className="Category-Item">
                  <div className={'ButtonGroup'} style={{ float: 'right' }}>
                    {/* {Button.component({
                      className: 'Button',
                      onclick: () => m.route.set(app.route("ticketComposer")),
                      icon: 'fas fa-edit',
                    }, app.translator.trans('v17development-flarum-support.forum.tickets.compose_ticket.title'))} */}
                  </div>

                  <h4>
                    <span>
                      <i className="fas fa-ticket-alt" />
                    </span>
                    {app.translator.trans('v17development-flarum-support.forum.tickets.overview.title')}
                  </h4>

                  <p>{app.translator.trans('v17development-flarum-support.forum.tickets.overview.description')}</p>
                </div>

                <div className={'Flarum-Support-Tickets-filter'}>
                  <div className={'Flarum-Support-Tickets-filter-quickfilter'}>
                    <div className={'Flarum-Support-Tickets-filter-status'}>
                      <TicketStatusFilter
                        filters={this.filter.status}
                        showSolved={this.filter.showSolved}
                        setFilter={(value) => this.setStatusFilter(value)}
                      />
                    </div>

                    <div className={'Flarum-Support-Tickets-filter-language'}>
                      <TicketLanguageFilter language={this.filter.language} setLanguage={(val) => this.updateFilter('language', val)} />
                    </div>

                    <div className={'Flarum-Support-Tickets-filter-assignee'}>
                      <TicketAssigneeFilter assignees={this.filter.assignees} filterAssignee={(val) => this.updateFilter('assignees', val)} />
                    </div>

                    <div className={'Flarum-Support-Tickets-filter-sort'}>
                      <SortTicketsFilter
                        sortColumn={this.filter.sortColumn}
                        sortDirection={this.filter.sortDirection}
                        setSort={(column, direction) => {
                          this.filter.sortColumn = column;
                          this.filter.sortDirection = direction;
                          this.loadData(true);
                        }}
                      />
                    </div>

                    {/* <div className={"Flarum-Support-Tickets-filter-search"}>
                      {Button.component({
                        className: `Button ${
                          this.showSearch ? "SearchActive" : ""
                        }`,
                        onclick: () => (this.showSearch = !this.showSearch),
                        title: "Refresh",
                        icon: "fas fa-search",
                      })}
                    </div> */}

                    <div className={'Flarum-Support-Tickets-filter-refresh'}>
                      <Tooltip text={app.translator.trans('v17development-flarum-support.forum.tickets.overview.refresh')}>
                        {Button.component({
                          className: `Button`,
                          disabled: this.data.isLoading,
                          onclick: () => this.loadData(true),
                          title: 'Refresh',
                          icon: 'fas fa-sync',
                        })}
                      </Tooltip>
                    </div>
                  </div>

                  {this.showSearch && (
                    <div className={'Flarum-Support-Tickets-filter-input'}>
                      <input type={'text'} value={''} onchange={() => {}} className={'FormControl'} placeholder={'Search'} />
                    </div>
                  )}
                </div>

                {/* Open tickets */}
                <div className={'Flarum-Support-Tickets-overview'}>
                  <div className={'Flarum-Support-Tickets-Overview-data'}>
                    <div className={'Flarum-Support-Tickets-Overview-data-header'}>
                      <span className={'Flarum-Support-Tickets-Overview-data--id'}>#</span>
                      <span className={'Flarum-Support-Tickets-Overview-data--info'}>
                        {app.translator.trans('v17development-flarum-support.forum.tickets.ticket')}
                      </span>
                      <span className={'Flarum-Support-Tickets-Overview-data--date'}>
                        {app.translator.trans('v17development-flarum-support.forum.tickets.opened_on')}
                      </span>
                      <span className={'Flarum-Support-Tickets-Overview-data--agents'}>
                        {app.translator.trans('v17development-flarum-support.forum.tickets.fields.assignees.title')}
                      </span>
                      <span className={'Flarum-Support-Tickets-Overview-data--status'}>
                        {app.translator.trans('v17development-flarum-support.forum.tickets.fields.status.title')}
                      </span>
                      <span className={'Flarum-Support-Tickets-Overview-data--settings'}></span>
                    </div>

                    {!this.data.isLoading && open.length === 0 && (
                      <div className={'Flarum-Support-No-tickets'}>
                        <p>{app.translator.trans('v17development-flarum-support.forum.tickets.overview.no_tickets')}</p>
                      </div>
                    )}

                    {open.map((ticket) => {
                      return <TicketOverviewAgencyTicketRow ticket={ticket} />;
                    })}

                    {this.data.isLoading && <LoadingIndicator containerClassName={'Flarum-Support-LoadingBig'} />}

                    {this.data.hasMore !== false && (
                      <div className={'load-more-tickets'}>
                        {Button.component(
                          {
                            className: 'Button',
                            onclick: () => this.loadData(false),
                            icon: 'far fa-arrow-alt-circle-down',
                            disabled: this.data.isLoading,
                          },
                          app.translator.trans('v17development-flarum-support.forum.tickets.load_more.title')
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  updateFilter(filter = 'language', value = null) {
    // Reset filter
    if (value === null) {
      this.filter[filter] = [];

      this.saveFilter();
      this.loadData(true);
      return;
    }

    let filterArray = this.filter[filter];

    const exitsInArray = filterArray.indexOf(value);

    // Add if not exists
    if (exitsInArray === -1) {
      filterArray.push(value);
    } else {
      filterArray.splice(exitsInArray, 1);
    }

    this.filter[filter] = filterArray;

    this.saveFilter();
    this.loadData(true);
  }

  setStatusFilter(filterOn = null) {
    if (this.data.isLoading) return;

    // Default selection
    if (filterOn === 'open' || filterOn === 'closed' || filterOn === 'solved') {
      if (filterOn === 'solved') {
        this.filter.showSolved = !this.filter.showSolved;
      } else {
        this.filter.status = filterOn === 'open' ? [0, 1, 4] : [3, 5];
        this.filter.showSolved = filterOn === 'closed';
      }
      this.saveFilter();
      this.loadData(true);
      return;
    }

    // Reset filter
    if (filterOn === null) {
      this.filter.showSolved = false;

      if (this.filter.status.length === 0) return;

      this.filter.status = [];

      this.saveFilter();
      this.loadData(true);

      return;
    }

    let filterArray = this.filter.status;

    const exitsInArray = filterArray.indexOf(filterOn);

    // Add if not exists
    if (exitsInArray === -1) {
      filterArray.push(filterOn);
    } else {
      filterArray.splice(exitsInArray, 1);
    }

    this.filter.status = filterArray;

    this.saveFilter();
    this.loadData(true);
  }

  /**
   * Save current filters to localstorage
   */
  saveFilter() {
    localStorage.filterTickets = JSON.stringify(this.filter);
  }

  /**
   * Get current filter
   * @returns object
   */
  getFilter() {
    const defaultFilter = {
      sortColumn: 'id',
      sortDirection: 'DESC',
      showSolved: false,
      language: [],
      assignees: [],
      status: [0, 1, 4],
    };

    try {
      const data = localStorage.filterTickets ? JSON.parse(localStorage.filterTickets) : defaultFilter;

      return {
        sortColumn: data.sortColumn ? data.sortColumn : 'id',
        sortDirection: data.sortDirection ? data.sortDirection : 'DESC',
        showSolved: data.showSolved ? data.showSolved : false,
        language: data.language ? data.language : [],
        assignees: data.assignees ? data.assignees : [],
        status: data.status ? data.status : [0, 1, 4],
      };
    } catch (error) {
      return defaultFilter;
    }
  }
}
